module.exports = __webpack_public_path__ + "media/dogs/dog-with-box-of-treats-47f5ace6.svg";